module.exports = __webpack_public_path__ + "static/media/timeline-login.528bac91.svg";